<template>
  <q-page class="page-background">
    <div class="q-pt-xl"></div>
    <div class="q-pa-xl flex flex-center text-center row">
      <div class="col-md-6 text-grey-3 text-h3 text-weight-medium q-pt-xl text-center">
        {{ t('herosection.welcome-h') }}
        <div class="text-h5 q-pt-md text-grey-3 text-center">{{ t('herosection.welcome-c') }}</div>
      </div>
    </div>
    <div class="q-pa-sm flex flex-center">
      <router-link to="/forum">
        <q-btn class="q-mt-xl" color="blue-5" size="20px" push>
          <div class="text-center">{{ t('herosection.join-btn') }}</div>
        </q-btn>
      </router-link>
    </div>
    <div class="q-pt-xl">
    <div class="q-mt-xl text-h6 text-center" style="color:#003D73">Proiect derulat de:</div>
    </div>
    <div class="q-mt-sm q-gutter-md row items-center justify-center">
      <img class="col-3 col-md-1" src="../assets/asptmr-1.png" />
      <img class="col-3 col-md-1" src="../assets/cmpp.png" />
      <img class="col-3 col-md-2" src="../assets/lhl.png" style="height:70px;" />
      <img class="col-3 col-md-1" src="../assets/raa.png" />
      <img class="col-3 col-md-2" src="../assets/unopa.png" style="height: 70px;" />
    </div>
  </q-page>
</template>

<style scoped>
/* .page-background {
  background: linear-gradient(45deg,rgba(10, 126, 141, 0.733),rgba(3, 161, 161, 0.603),rgba(4, 129, 102, 0.301));
} */
.page-background {
  background-image: linear-gradient(45deg,rgba(157, 211, 243, 0.507),rgba(0, 33, 133, 0.486)),url("../assets/clouds.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}
</style>

<script>
import { useI18n } from 'vue-i18n';
import 'animate.css';

export default {
  name: "HeroSection",
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: 'local'
    });
    return { t }
  }
};
</script>
